getAllOptionPath